import { FormsModule } from '@angular/forms';
import { MbscModule } from '@mobiscroll/angular';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';

import { environment } from '../environments/environment';

import { NgbNavModule, NgbAccordionModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { ScrollToModule } from '@nicky-lenaers/ngx-scroll-to';

import { LayoutsModule } from './layouts/layouts.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { CrystalLightboxModule } from '@crystalui/angular-lightbox';
import { AngularFireModule } from '@angular/fire';
import { AngularFirestoreModule } from '@angular/fire/firestore';
/////더미
import { ExcelService } from './core/services/excel.service';
import { PipeModule } from './core/pipes/pipe.module';

import { LOCALE_ID } from '@angular/core';
import localeKo from '@angular/common/locales/ko';
import { registerLocaleData } from '@angular/common';
registerLocaleData(localeKo, 'ko');

@NgModule({
  declarations: [AppComponent],
  imports: [
    FormsModule,
    MbscModule,
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFirestoreModule,
    CrystalLightboxModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    LayoutsModule,
    AppRoutingModule,
    CarouselModule,
    NgbAccordionModule,
    NgbNavModule,
    NgbTooltipModule,
    ScrollToModule.forRoot(),
    PipeModule,
  ],
  providers: [ExcelService, { provide: LOCALE_ID, useValue: 'ko-KO' }],
  bootstrap: [AppComponent],
})
export class AppModule {}
